import { LIGHT_PINK, MAIN_BLUE } from "../styles";

const styles = {
  link: {
    color: LIGHT_PINK,
    textDecorationColor: LIGHT_PINK,
    textUnderlineOffset: "5px",
  },
  header: { color: MAIN_BLUE, fontSize: { xs: 20, md: 30 } },
  letGoButton: { backgroundColor: "#507dbe", color: "white", px: 3 },
  limitedTime: {
    backgroundColor: "transparent",
    color: LIGHT_PINK,
  },
};

export default styles;
